<template>
  <v-container tag="section">
    <material-wizard
      v-model="tab"
      title="Nova Importação BDGD"
      subtitle="Selecione o mês, versão e entidades que serão importadas do Geon"
      :available-steps="availableSteps"
      :tabs="tabs"
      class="mx-auto"
      :loading="loading"
      :disabled-btn-finalizar="validTabs[tab + 1] === false"
      @click:next="next(1)"
      @click:prev="tab--"
    >
      <importacao-bdgd-wizard-tabs
        ref="importacaoBdgdParametros"
        :items="dados"
        @stepReleased="validTabs[$event.numberStep] = $event.available"
      />
    </material-wizard>
  </v-container>
</template>

<script>
  import ImportacoesBdgdService from '@/services/ImportacoesBdgdService.js';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      ImportacaoBdgdWizardTabs: () => import('@/components/importacoesBdgd/ImportacaoBdgdWizardTabs'),
      MaterialWizard: () => import('@/components/base/MaterialWizard')
    },

    mixins: [tourMixins],

    data: () => ({
      tab: 0,
      tabs: ['Mês dos Dados', 'Entidades'],
      loading: false,
      dados: {},
      validTabs: { 0: true, 1: false, 2: undefined } /* 0 = 'Datas', 1 = 'Entidades', 2 = 'finish' */,
      availableSteps: [0],
      arrPrimeiraTabTour: [
        {
          element: '#first-step-importacao-table',
          intro: 'Aqui você deverá selecionar o mês e a versão que será importada.',
          scrollTo: 'tooltip',
          position: 'top'
        }
      ],
      arrSegundaTabTour: [
        {
          element: '#second-step-search',
          intro: 'Neste campo você poderá pesquisar por entidades específicas.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#second-step-importacao-table',
          intro: 'Aqui você deverá selecionar as entidades que serão importadas.',
          scrollTo: 'tooltip',
          position: 'top'
        }
      ]
    }),

    computed: {
      user() {
        return this.$store.getters.getUser;
      }
    },

    mounted() {
      this.iniciarPrimeiraTabTour();
    },

    methods: {
      next(valid) {
        if (!valid) return;

        if (this.tab === this.tabs.length - 1) {
          this.save();
        } else {
          this.tab++;
        }
        this.$forceUpdate();
      },

      save() {
        const data = this.$refs.importacaoBdgdParametros.exportData();
        this.loading = true;

        ImportacoesBdgdService.salvar(data)
          .then(() => {
            this.$toast.success('Importação de BDGD salva com sucesso.', '', { position: 'topRight' });
            this.$router.push({ name: 'Importações BDGD Histórico' });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao salvar a Importação de BDGD.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },

      iniciarPrimeiraTabTour() {
        this.doneLabel = 'Proximo';
        this.desativarTourAoSair = false;

        let onBeforeExitFunction = {
          func: () => {
            this.tab = 1;
            this.iniciarSegundaTabTour();
          }
        };

        this.iniciarTour(this.arrPrimeiraTabTour, [], [], [onBeforeExitFunction]);
      },

      iniciarSegundaTabTour() {
        this.doneLabel = 'Finalizar';
        this.desativarTourAoSair = true;

        let onBeforeExitFunction = {
          func: () => (this.tab = 0)
        };

        this.iniciarTour(this.arrSegundaTabTour, [], [], [onBeforeExitFunction]);
      }
    },

    watch: {
      validTabs: {
        handler() {
          for (let i = 1; i <= 2; i++) {
            if (this.validTabs[i] && this.validTabs[i - 1]) {
              this.availableSteps.push(i);
            } else {
              this.availableSteps = this.availableSteps.filter((key) => key != i);
            }
          }
          if (this.validTabs[1] && this.validTabs[2] == undefined) this.availableSteps.push(2);
        },
        deep: true
      }
    }
  };
</script>